import React, { forwardRef } from 'react';
import Layout from '../Layout';
import { AspectRatioProps } from './types';

const AspectRatio = forwardRef<HTMLElement, AspectRatioProps>(
  ({ children, ratio = '1', overflow = { default: 'hidden' }, ...restProps }: AspectRatioProps, ref) => (
    <Layout ref={ref} ratio={ratio} overflow={overflow} {...restProps}>
      {children}
    </Layout>
  )
);

AspectRatio.displayName = 'AspectRatio';

export default AspectRatio;
